import type { PlaidAccountCategory } from "@components/PlaidConnectFlow/types";

/**
 * `request_portfolio` 工具的可选 `intentSide`（perplexica schema，EDG-543 Phase 5）。
 * 缺省 = `both` = 双卡（**存量行为**）。
 */
export const INTENT_SIDE_VALUES = ["invest", "banking", "both"] as const;

export type IntentSide = (typeof INTENT_SIDE_VALUES)[number];

/**
 * `intentSide` → `AccountCategoryCards.only`。
 *
 * `both` / 缺省 / 非法值一律 `undefined`（双卡）—— 模型给出意料之外的值时必须回落到
 * 现状而不是少渲染一张卡：少一张就是把用户能连的账户类型直接砍掉，比多一张严重得多。
 */
export function mapIntentSideToCategory(
  intentSide: string | null | undefined,
): PlaidAccountCategory | undefined {
  switch (intentSide?.trim()) {
    case "invest":
      return "invest";
    case "banking":
      return "bank";
    default:
      return undefined;
  }
}
